import client from '../core/client';
import { getBodyData } from '../utils';

export default (parent_id) => getBodyData(client.get('/v1/political_division/', {
  params: { parent_id },
}));

